import { useEffect } from 'react';

import { useOktaAuth } from '@okta/okta-react';
import DOMPurify from 'dompurify';

import { deleteRedcarpetCookies, getAppConfig, updateSessionStorage } from '../../../common/utilities';

const RedirectSecured = ({ children }) => {
  const auth = useOktaAuth();
  const { authState, oktaAuth } = auth;

  const isUserAuthenticated = () => {
    const { path = '' } = getAppConfig('server');
    const { redirectAfterLogin } = getAppConfig('login');
    if (authState && authState.isAuthenticated) {
      const originalUri = oktaAuth.getOriginalUri();
      const redirect = originalUri || `${path}${redirectAfterLogin}`;
      window.location.pathname = DOMPurify.sanitize(redirect);
    } else {
      updateSessionStorage.clear();
      deleteRedcarpetCookies();
    }
  };

  useEffect(() => {
    isUserAuthenticated();
  }, []);

  return children;
};

export default RedirectSecured;
